import { Currency } from '../Currency'
import { NativeCurrency } from '../NativeCurrency'
import { Token } from '../Token'
import { WETH9 } from '../../constants/tokens'
import invariant from 'tiny-invariant'

/**
 * Plasm is the main usage of a 'native' currency, i.e. for Plasm mainnet and all testnets
 */
export class Plasm extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'PLD', 'Plasm')
  }

  public get wrapped(): Token {
    const weth9 = WETH9[this.chainId]
    invariant(!!weth9, 'WRAPPED')
    return weth9
  }

  private static _cache: { [chainId: number]: Plasm } = {}

  public static onChain(chainId: number): Plasm {
    return this._cache[chainId] ?? (this._cache[chainId] = new Plasm(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
